import React, { useEffect, useState } from "react";
import { Box, Text, Spinner, Container } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
import * as mod from "../../url";

const SIDEBAR_WIDTH = "250px";

const SingleDraftPage = () => {
  const { slug } = useParams();
  const [drafts, setDrafts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDraft = async () => {
      try {
        const { data } = await axios.get(
          `${mod.api_url}/api/v1/draft/get_drafts/${slug}`
        );
        setDrafts(data);
      } catch (error) {
        console.error("Failed to fetch draft", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDraft();
  }, [slug]);

  if (loading)
    return (
      <Box textAlign="center" mt="100px">
        <Spinner size="xl" />
      </Box>
    );

  if (!drafts)
    return (
      <Text color="red.500" mt="100px" textAlign="center">
        Draft not found
      </Text>
    );

  return (
    <>
      <Navbar />
      <Sidebar />
      <Container maxW="7xl" py={8}>
        <Box mt="100px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={2}>
          {/* Author and Date */}
          <Text color="black" mb={4}>
            {/* {drafts.author} | {new Date(drafts.date).toLocaleDateString()} */}
          </Text>

          {/* Draft content box (clean, no borders) */}
          <Box
            bg="white"
            // borderRadius="6px"
            // overflow="hidden"
            // boxShadow="sm"
            // border="1px solid #e2e8f0"
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "14pt",
              lineHeight: "1.8",
              whiteSpace: "pre-wrap",
              textAlign: "justify",
            }}
          >
            <ReactQuill
              value={drafts.des} // HTML from backend
              readOnly={true}
              theme="bubble" // ✅ bubble theme has no border or toolbar
              style={{
                minHeight: "500px",
                background: "transparent",
                border: "none",
                padding: 0,
                margin: 0,
              }}
            />
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default SingleDraftPage;
